import {
  GET_BENEFIT_ITEMS_LIST,
  GET_BENEFIT_ITEMS_LIST_SUCCESS,
  GET_BENEFIT_ITEMS_LIST_ERROR,
  GET_BENEFIT_ITEMS_LIST_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BenefitItemsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_ITEMS_LIST:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_ITEMS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_ITEMS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case GET_BENEFIT_ITEMS_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BenefitItemsList;
